import { AbstractBlockFactory } from '../block/AbstractBlockFactory';
import { BlockType, ComponentSettings, NewBlockContextType } from '@report-content';
import { AssocArray } from 'tools/types';

export class BlockFactoryLlm extends AbstractBlockFactory<ComponentSettingsLlm> {
    public getNewBlock({
        nextUId,
        nextSortOrder,
        datasetFields,
    }: NewBlockContextType): BlockType<ComponentSettingsLlm> {
        const uid = 'block_uid_' + nextUId;
        return {
            // TODO:
            component: {
                datasetRendererBlockComponentId: nextUId,
                datasetRendererBlockId: nextUId,
                datasetRendererComponentId: nextUId,
                displayOrder: nextSortOrder,
                internalName: 'llm',
                settings: {
                    groupFilter: { operator: 'AND', rules: [] },
                    component_name: 'LLM Component',
                    uid: uid,
                    internal_name: 'llm',
                    title: '',
                    prompt: '',
                    height: 200,
                    show_in_viewer: 'Y',
                    is_preview_ind: 'N',
                    include_in_email: 'Y',
                    include_in_email_attachment: 'Y',
                    is_collapsed_ind: 'N',
                    isOnCreation: true,
                },
            },
            // datasetRendererBlockId: number;
            displayOrder: nextSortOrder,
            // elementId: number;
            uid: uid,
        };
    }
}

export interface ComponentSettingsLlm extends ComponentSettings {
    uid: string;
    component_name: 'LLM Component';
    prompt: string;
}

export interface LlmInitialDataResponse {
    response: string;
}
